import { Component, OnInit } from '@angular/core';
import { Contract, Data } from '@mlc/types';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { of, switchMap } from 'rxjs';
import { ClientRequestStatusEnum } from 'src/app/core/models/enums/clientRequestStatus.eum';
import { Request } from 'src/app/core/models/request.model';
import { RequestService } from 'src/app/core/services/request/request.service';
import { ContractService } from 'src/app/core/services/wallet/wallet.service';

@UntilDestroy()
@Component({
  selector: 'app-request-card',
  templateUrl: './request-card.component.html',
  styleUrls: ['./request-card.component.scss'],
  standalone: false
})
export class RequestCardComponent  implements OnInit {

  constructor( 
    private contractService: ContractService, 
    private requestService: RequestService
  ) { }

  public lastClientRequestState: ClientRequestStatusEnum = ClientRequestStatusEnum.FUNDS_INVESTED;
  public contract!: Data<Contract>;
  public busy: boolean = true;
  public requests!: Data<Request>[];

  ngOnInit() {
    this.contractService.get()
    .pipe(
      untilDestroyed(this),
      switchMap((contract: Data<Contract> | undefined) => {
        if (!contract) {
          this.busy = false;
          return of([]);
        }
        this.contract = contract;
        return this.requestService.findAllRequest(contract.id);
      })
    )
    .subscribe((requests: Data<Request>[]) => {
      this.requests = requests;
      this.busy = false;
    });
  }
}
